import "./Imprint.module.css";
import Header from "@/reusable_sections/Header";
import Impressum from "./sections/Impressum";
import Footer from "@/reusable_sections/Footer";
export default function ImprintPage() {
  return <div>
      <Header />
      <Impressum />
      <Footer />
    </div>;
}